





















































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import { PositionDataModule } from '@/app/store/modules/position'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public clearRowSelected

  public randomWord: string = ''
  public randomCode() {
    const word = 'ABCDEFGHIJKLMNOPQRSTUVWXTZ'
    const max = 3
    let random = ''
    for (let i = 0; i < max; i++) {
      const hasil = Math.floor(Math.random() * word.length)
      random += word.substring(hasil, hasil + 1)
    }
    return (this.randomWord = random)
  }

  public text = ''

  public resetText() {
    this.text = ''
    this.funcSearch()
  }

  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public description = ''
  public resetAdd() {
    this.$v.description.$reset()
    this.description = ''
  }

  public postPosition(item, index, button) {
    this.randomCode()
    this.$v.description.$touch()
    if (this.$v.description.$invalid) {
      return
    } else {
      const dataToPost = {
        code: this.randomWord,
        description: this.description,
      }
      PositionDataModule.postPosition(dataToPost)
      this.$root.$emit('bv::hide::modal', index, button)
    }
  }

  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  // delete data
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }
}
